import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CustomToastContainer } from './components/toast/custom-react-toastify/v1';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
const theme = createTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // queryFn: getQueryFn({ on401: "throw" }),
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    container,
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CustomToastContainer />
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  );
} else {
  root.render(
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CustomToastContainer />
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
